"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantProvider = void 0;
const day_names_1 = require("./../constant-values/day-names");
const month_names_1 = require("./../constant-values/month-names");
const month_shortnames_1 = require("./../constant-values/month-shortnames");
class ConstantProvider {
    static getDayNames(locale) {
        if (locale in day_names_1.DayNames)
            return day_names_1.DayNames[locale];
        return day_names_1.DayNames["default"];
    }
    static getMonthNames(locale) {
        if (locale in month_names_1.MonthNames)
            return month_names_1.MonthNames[locale];
        return month_names_1.MonthNames["default"];
    }
    static getMonthShortNames(locale) {
        if (locale in month_shortnames_1.MonthShortNames)
            return month_shortnames_1.MonthShortNames[locale];
        return [];
    }
}
exports.ConstantProvider = ConstantProvider;
